import { Logo } from "@/components/brand/logo";

// Shown as the Suspense fallback while the AppLayout chunk loads on first
// sign-in (and after a hard refresh on `/app` / `/admin`). Without this the
// fallback was `null`, which painted a blank white frame for the duration
// of the chunk fetch — users reported a "flicker" / "blank" / "stuck"
// experience right after clicking the magic-link button or completing the
// OAuth callback.
//
// Keep this component dependency-free (no react-query, no router) so it
// renders the instant the lazy boundary suspends. Anything heavier defeats
// the purpose.
export function AuthLoadingScreen() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background"
      role="status"
      aria-live="polite"
      aria-label="Loading"
      data-testid="auth-loading-screen"
    >
      <div className="flex flex-col items-center gap-4">
        <Logo variant="mark" height={40} alt="" />
        <p className="text-sm text-muted-foreground">Loading your workspace…</p>
      </div>
    </div>
  );
}
